export const H1 = ({ children, className = "" }) => (
  <h1 className={`${className} h1`}>{children}</h1>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`${className} h2`}>{children}</h2>
);

export const H3 = ({ children, className = "" }) => (
  <h3 className={`${className} h3`}>{children}</h3>
);

export const B1 = ({ children, className = "" }) => (
  <p className={`${className} b1`}>{children}</p>
);
export const B2 = ({ children, className = "" }) => (
  <p className={`${className} b2`}>{children}</p>
);
export const B3 = ({ children, className = "" }) => (
  <p className={`${className} b3`}>{children}</p>
);

export const L = ({ children, forInput, className, size, ...props }) => (
  <label className={`${className} ${size}`} htmlFor={forInput} {...props}>
    {children}
  </label>
);

export const SLable = ({ children, className, size, ...props }) => (
  <span className={`supporting-text ${className} ${size}`} {...props}>
    {children}
  </span>
);

export const SLableIcon = ({
  children,
  className,
  size,
  icon: Icon = null,
  ...props
}) => (
  <span className={`supporting-text withIcon ${className}  ${size}`} {...props}>
    {Icon && (
      <span className="icon-parent">
        <Icon size={size} className="icon" />
      </span>
    )}
    <span>{children}</span>
  </span>
);
